import { RT_Element } from "../types";
import { HeadingElementStatic, ParagraphElementStatic } from "./elements";

// ---------------------------------------------------------------------- //

type Props = {
  element: RT_Element;
  children: React.ReactNode;
};

export function ElementRenderStatic(props: Props) {
  switch (props.element.type) {
    case "heading":
      return <HeadingElementStatic {...props} element={props.element} />;
    //
    case "paragraph":
      return <ParagraphElementStatic {...props} element={props.element} />;
    //
    default:
      return null;
  }
}
